import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import styled, { keyframes } from "styled-components";
import './GradientCycle.css';


const GradientContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;


const fadeInBlur = keyframes`
  from {
    opacity: 0;
    filter: blur(5px);
  }
  to {
    opacity: 1;
    filter: blur(0);
  }
`;

const BottomLeftContainer = styled.div`
  position: absolute;
  bottom: 60px; /* Anchors the container to the bottom */
  left: 20px; /* Anchors the container to the left */
  color: white;
  z-index: 2;
  @media (max-width: 768px) {
  bottom: 105px;
    font-size: 1.85rem;
    line-height: 1.5rem;
}
`;

const BottomLeftText = styled.div`
  font-size: 3.5rem;
  line-height: 3.5rem;
  font-family: 'MagicalParadise', sans-serif;
  opacity: 0; /* Initial state for fade-in */
  animation: ${fadeInBlur} 1s ease-out forwards; /* Triggers fade-in on render */
  animation-delay: .5s; /* Optional delay before animation starts */
  @media (max-width: 768px) {
    font-size: 1.85rem;
    line-height: 1.5rem;
}
`;

const BottomLeftSmallText = styled.div`
  font-size: 1.25rem;
  width: 55%;
  line-height: 1.5rem;
  font-family: Arial, sans-serif;
  margin-top: 10px; /* Adds some spacing between the two texts */
    opacity: 0; /* Initial state for fade-in */
  animation: ${fadeInBlur} 1s ease-out forwards;
  animation-delay: 1.5s; /* Smaller text appears after the title */
   @media (max-width: 768px) {
   width: 90%;
    font-size: 1rem;
    line-height: 1.25rem;
}
`;

const TopRightText = styled.div`
 opacity: 0; /* Initial state for fade-in */
  animation: ${fadeInBlur} 1s ease-out forwards;
  animation-delay:  2s; /* Smaller text appears after the title */
  position: absolute;
  top: 20px;
  right: 20px;
  color: white;
  font-family: Arial, sans-serif;
  z-index: 2;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* Align text to the right */

   /* Styles for nested p tags */
  p {
  
    margin: 0; /* Adjust the margin as needed */
  }

  /* Additional styling for bold text in p tags */
  p b {
    font-weight: bold;
    color: #fff; /* Example: Make the bold text black */
  }

  @media (max-width: 1024px) {
    top: 15px;
    right: 15px;
  }

  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
  }
`;

const TitleText = styled.div`
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-family: 'HomeVideo', sans-serif;
  font-weight: bold;
  text-align: right;

  @media (max-width: 1024px) {
    font-size: 1.3rem;
    margin-bottom: 0.75rem;
  }

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }
`;

const TimerText = styled.div`
  color: white;
  font-size: .9rem;
  margin-top: 5px;
  text-align: right;

  @media (max-width: 1024px) {
    font-size: 0.9rem;
    margin-top: 4px;
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;
    margin-top: 3px;
  }
`;

const NextCityText = styled.div`
  color: white;
  font-size: .9rem;
  margin-top: 10px;
  text-align: right;

  @media (max-width: 1024px) {
    font-size: 0.9rem;
    margin-top: 8px;
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;
    margin-top: 5px;
  }
`;

const HeadlinesContainer = styled.div`
  color: white;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  text-align: right;
  line-height: .9rem;
  margin-bottom:.5rem;

  @media (max-width: 768px) {
    display: none; /* Hide headlines on mobile screens */
  }
`;


const AboutText = styled.div`
  color: white;
  max-width: 260px; /* Constrain width for readability */
  font-size: 0.75rem;
  margin-top: 1.5rem; /* Add spacing above the about section */
  line-height: .9rem;
  text-align: right;

  @media (max-width: 1024px) {
    font-size: 0.7rem;
    margin-top: 1rem;
  }

  @media (max-width: 768px) {
    font-size: 0.65rem;
    margin-top: 0.75rem;
    max-width: 230px; /* Reduce width on smaller screens */
  }
`;

const MobileScrollText = styled.div`
  display: none;
  font-size: 1rem;
  text-align: left;
  color: white;
  font-family: Arial, sans-serif;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: left;
    gap: 8px; /* Space between text and the arrow */
  }
`;

const ArrowCircle = styled.span`
  display: inline-flex;
  justify-content: left;
  align-items: center;
  width: 24px;
  height: 10px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
`;
const ReachOutButton = styled.a`
  display: inline-block;
  padding: 10px 10px;
  font-size: 14px;
  color: #f2f2f2;
  margin-top:.7rem;
  background: #444;
  border-radius: 30px;
  text-decoration: none;
  text-align: center;
  font-weight: bold;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #f2f2f2;
    color: #262626;
  }
&::after {
    content: " →";
  }
  @media (max-width: 768px) {
  background: rgba(68, 68, 68, 0.4); /* Reduced opacity */
  font-size: 13px;
   width:60%;
    padding: 10px 0; /* Adjust padding for centered content */
    border-radius: 20px; /* Slightly less rounded on full width */
    text-align: center;
  }
`;

const GRADIENTS = {
  concerned: ["#FF8C00", "#FFA500", "#FFD700"], // Warm tones to convey worry and urgency
  alarmed: ["#B20000", "#FF4500", "#FF6347"], // Shades of red
  amazed: ["#FFD700", "#FFFF00", "#FFFACD"], // Shades of yellow
  amused: ["#FFC0CB", "#FF69B4", "#FF1493"], // Shades of pink
  astonished: ["#FF4500", "#FF6347", "#FFA07A"], // Shades of red-orange
  awed: ["#8A2BE2", "#9370DB", "#BA55D3"], // Shades of purple
  calm: ["#87CEFA", "#4682B4", "#5F9EA0"], // Shades of blue
  cheerful: ["#FFD700", "#FFA500", "#FF4500"], // Shades of yellow-orange
  comfortable: ["#20B2AA", "#66CDAA", "#B0E0E6"], // Shades of teal
  confident: ["#32CD32", "#00FF7F", "#3CB371"], // Shades of green
  contemplative: ["#2F4F4F", "#708090", "#778899"], // Shades of gray-blue
  content: ["#FFDAB9", "#F5DEB3", "#FFE4B5"], // Shades of peach
  courageous: ["#FF6347", "#FF4500", "#DC143C"], // Shades of red-orange
  determined: ["#FFA500", "#FF8C00", "#FF4500"], // Shades of orange
  dignified: ["#8B0000", "#B22222", "#DC143C"], // Shades of dark red
  dreamy: ["#9370DB", "#BA55D3", "#8A2BE2"], // Shades of lavender
  eager: ["#FF7F50", "#FF6347", "#FF4500"], // Shades of coral
  ecstatic: ["#FFD700", "#FFA500", "#FF8C00"], // Shades of yellow-orange
  empathetic: ["#FFC0CB", "#FFB6C1", "#FF69B4"], // Shades of pink
  empowered: ["#32CD32", "#00FA9A", "#7CFC00"], // Shades of bright green
  energetic: ["#FFA500", "#FF4500", "#FF6347"], // Shades of orange-red
  enlightened: ["#FFFACD", "#FFD700", "#FFFF00"], // Shades of gold
  enthralled: ["#8A2BE2", "#9370DB", "#BA55D3"], // Shades of purple
  excited: ["#FF4500", "#FF6347", "#FFA07A"], // Shades of red-orange
  exhilarated: ["#FFD700", "#FFA500", "#FF8C00"], // Shades of amber
  fulfilled: ["#FFDAB9", "#FFE4B5", "#F5DEB3"], // Shades of peach
  grateful: ["#FFD700", "#FFFF00", "#FFFACD"], // Shades of gold
  happy: ["#FFFF00", "#FFD700", "#FFA500"], // Shades of yellow-orange
  harmonious: ["#20B2AA", "#66CDAA", "#B0E0E6"], // Shades of teal
  hopeful: ["#76C893", "#52B788", "#34A853"],// Shades of green
  hyper: ["#FF4500", "#FF6347", "#FFA07A"], // Shades of red-orange
  idyllic: ["#00FA9A", "#32CD32", "#7CFC00"], // Shades of aqua
  important: ["#FFA500", "#FF8C00", "#FF4500"], // Shades of orange
  impressed: ["#FFD700", "#FFFF00", "#FFFACD"], // Shades of yellow
  inspired: ["#FFA07A", "#FF4500", "#FF6347"], // Shades of coral
  interested: ["#9370DB", "#BA55D3", "#8A2BE2"], // Shades of purple
  joyful: ["#FFD700", "#FFFF00", "#FFA500"], // Shades of yellow-orange
  jubilant: ["#FFA500", "#FF4500", "#FF6347"], // Shades of orange
  liberated: ["#32CD32", "#00FA9A", "#7CFC00"], // Shades of aqua
  lighthearted: ["#FFDAB9", "#FFE4B5", "#F5DEB3"], // Shades of peach
  loving: ["#FF69B4", "#FFC0CB", "#FF1493"], // Shades of pink-red
  mellow: ["#4682B4", "#5F9EA0", "#87CEFA"], // Shades of blue
  nostalgic: ["#8A2BE2", "#9370DB", "#BA55D3"], // Shades of lavender
  optimistic: ["#32CD32", "#00FA9A", "#7CFC00"], // Shades of aqua
  peaceful: ["#20B2AA", "#66CDAA", "#B0E0E6"], // Shades of teal
  playful: ["#FF69B4", "#FFC0CB", "#FFB6C1"], // Shades of pink
  proud: ["#FFD700", "#FFA500", "#FF8C00"], // Shades of yellow-orange
  refreshed: ["#00FA9A", "#32CD32", "#7CFC00"], // Shades of aqua
  rejuvenated: ["#87CEFA", "#4682B4", "#5F9EA0"], // Shades of blue
  relaxed: ["#B0E0E6", "#66CDAA", "#20B2AA"], // Shades of teal
  relieved: ["#FFE4B5", "#F5DEB3", "#FFDAB9"], // Shades of peach
  safe: ["#4682B4", "#5F9EA0", "#87CEFA"], // Shades of blue
  satisfied: ["#FFD700", "#FFA500", "#FF8C00"], // Shades of yellow-orange
  sentimental: ["#FFB6C1", "#FFC0CB", "#FF69B4"], // Shades of pink
  silly: ["#FF69B4", "#FFC0CB", "#FFB6C1"], // Shades of pink
  surprised: ["#FF00FF", "#EE82EE", "#DA70D6"], // Shades of violet
  thankful: ["#FFD700", "#FFFF00", "#FFFACD"], // Shades of gold
  thoughtful: ["#778899", "#708090", "#2F4F4F"], // Shades of gray-blue
  touched: ["#FFB6C1", "#FFC0CB", "#FF69B4"], // Shades of pink
  trustful: ["#32CD32", "#00FA9A", "#7CFC00"], // Shades of aqua
  warm: ["#FF4500", "#FF6347", "#FFA07A"], // Shades of orange-red
  alienated: ["#2F4F4F", "#708090", "#778899"], // Shades of gray-blue
  angry: ["#8B0000", "#B22222", "#DC143C"], // Shades of red
  annoyed: ["#FFA07A", "#FF4500", "#FF6347"], // Shades of orange-red
  anxious: ["#FFD700", "#FF4500", "#FF6347"], // Shades of yellow-red
  apathetic: ["#808080", "#696969", "#A9A9A9"], // Shades of gray
  apprehensive: ["#FFA500", "#FFA07A", "#FF4500"], // Shades of orange-red
  bored: ["#708090", "#778899", "#2F4F4F"], // Shades of gray-blue
  brooding: ["#4B0082", "#483D8B", "#2E0854"], // Shades of dark purple
  cold: ["#87CEFA", "#4682B4", "#5F9EA0"], // Shades of blue
  confining: ["#8B0000", "#B22222", "#DC143C"], // Shades of red
  confused: ["#808080", "#A9A9A9", "#696969"], // Shades of gray
  cranky: ["#FFA07A", "#FF6347", "#FF4500"], // Shades of orange-red
  critical: ["#FF4500", "#FF6347", "#DC143C"], // Shades of red-orange
  crushed: ["#708090", "#778899", "#2F4F4F"], // Shades of gray-blue
  cynical: ["#696969", "#A9A9A9", "#808080"], // Shades of gray
  depressed: ["#00008B", "#0000FF", "#1E90FF"], // Shades of blue
  desolate: ["#4B0082", "#483D8B", "#2E0854"], 
  devastated: ["#2E0854", "#4B0082", "#483D8B"],// Shades of dark purple
  disappointed: ["#778899", "#708090", "#2F4F4F"], // Shades of gray-blue
  discontented: ["#808080", "#696969", "#A9A9A9"], // Shades of gray
  dismayed: ["#FFA07A", "#FF6347", "#FF4500"], // Shades of orange-red
  distressed: ["#B22222", "#FF4500", "#DC143C"], // Shades of red
  drained: ["#A9A9A9", "#808080", "#696969"], // Shades of gray
  embarrassed: ["#FFB6C1", "#FFC0CB", "#FF69B4"], // Shades of pink
  empty: ["#2F4F4F", "#708090", "#778899"], // Shades of gray-blue
  envious: ["#556B2F", "#6B8E23", "#7FFF00"], // Shades of green
  exhausted: ["#A9A9A9", "#808080", "#696969"], // Shades of gray
  fatalistic: ["#2F4F4F", "#708090", "#778899"], // Shades of gray-blue
  foreboding: ["#4B0082", "#483D8B", "#2E0854"], // Shades of dark purple
  frightened: ["#483D8B", "#4B0082", "#8A2BE2"], // Shades of dark blue
  frustrated: ["#DC143C", "#FF4500", "#FF6347"], // Shades of red-orange
  futile: ["#A9A9A9", "#808080", "#696969"], // Shades of gray
  gloomy: ["#2F4F4F", "#708090", "#778899"], // Shades of gray-blue
  grumpy: ["#FF4500", "#FFA07A", "#FF6347"], // Shades of orange-red
  haunting: ["#4B0082", "#483D8B", "#2E0854"], // Shades of dark purple
  heartbroken: ["#708090", "#778899", "#2F4F4F"], // Shades of gray-blue
  hesitant: ["#4682B4", "#5F9EA0", "#87CEFA"], // Shades of blue
  hopeless: ["#00008B", "#0000FF", "#1E90FF"], // Shades of blue
  hostile: ["#8B0000", "#B22222", "#DC143C"], // Shades of red
  humiliated: ["#FF69B4", "#FFC0CB", "#FFB6C1"], // Shades of pink
  indifferent: ["#A9A9A9", "#808080", "#696969"], // Shades of gray
  intimidated: ["#483D8B", "#4B0082", "#8A2BE2"], // Shades of dark blue
  irritated: ["#FFA07A", "#FF6347", "#FF4500"], // Shades of orange-red
  isolated: ["#708090", "#778899", "#2F4F4F"], // Shades of gray-blue
  lethargic: ["#696969", "#808080", "#A9A9A9"], // Shades of gray
  lonely: ["#00008B", "#0000FF", "#1E90FF"], // Shades of blue
  melancholic: ["#4B0082", "#483D8B", "#2E0854"], // Shades of dark purple
  morose: ["#708090", "#778899", "#2F4F4F"], // Shades of gray-blue
  nauseated: ["#556B2F", "#6B8E23", "#7FFF00"], // Shades of green
  nervous: ["#FFA07A", "#FF6347", "#FF4500"], // Shades of orange-red
  nightmarish: ["#4B0082", "#483D8B", "#2E0854"], // Shades of dark purple
  numb: ["#A9A9A9", "#808080", "#696969"], // Shades of gray
  overwhelmed: ["#FF4500", "#DC143C", "#B22222"], // Shades of red
  painful: ["#B22222", "#FF4500", "#DC143C"], // Shades of red
  pensive: ["#708090", "#778899", "#2F4F4F"], // Shades of gray-blue
  perplexed: ["#808080", "#A9A9A9", "#696969"], // Shades of gray
  pessimistic: ["#2F4F4F", "#708090", "#778899"], // Shades of gray-blue
  powerless: ["#A9A9A9", "#808080", "#696969"], // Shades of gray
  rejected: ["#708090", "#778899", "#2F4F4F"], // Shades of gray-blue
  remorseful: ["#778899", "#708090", "#2F4F4F"], // Shades of gray-blue
  restless: ["#FFA07A", "#FF6347", "#FF4500"], // Shades of orange-red
  scared: ["#483D8B", "#4B0082", "#8A2BE2"], // Shades of dark blue
  sceptical: ["#808080", "#A9A9A9", "#696969"], // Shades of gray
  serious: ["#2F4F4F", "#708090", "#778899"], // Shades of gray-blue
  shocked: ["#FF00FF", "#DA70D6", "#EE82EE"], // Shades of violet
  sick: ["#556B2F", "#6B8E23", "#7FFF00"], // Shades of green
  sombre: ["#4B0082", "#483D8B", "#2E0854"], // Shades of dark purple
  stressed: ["#B22222", "#FF4500", "#DC143C"], // Shades of red
  suspenseful: ["#4B0082", "#483D8B", "#2E0854"], // Shades of dark purple
  suspicious: ["#FFA07A", "#FF6347", "#FF4500"], // Shades of orange-red
  tense: ["#DC143C", "#FF4500", "#B22222"], // Shades of red
  terrified: ["#483D8B", "#4B0082", "#8A2BE2"], // Shades of dark blue
  threatened: ["#DC143C", "#FF4500", "#B22222"], // Shades of red
  uncomfortable: ["#FFA07A", "#FF6347", "#FF4500"], // Shades of orange-red
  vengeful: ["#8B0000", "#B22222", "#DC143C"], // Shades of red
  vulnerable: ["#A9A9A9", "#808080", "#696969"],
  worried: ["#FFA07A", "#FFDAB9", "#FFC0CB"], 
  neutral: ["#C0C0C0", "#808080", "#2F4F4F"],
};


const TIMER_INTERVAL = 60;

const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60).toString().padStart(2, "0");
  const secs = (seconds % 60).toString().padStart(2, "0");
  return `${mins}:${secs}`;
};


const getGradientColors = (mood) => {
  const gradientColors = GRADIENTS[mood] || GRADIENTS["neutral"];
  console.log(`Getting gradient colors for mood: ${mood}`, gradientColors);
  return gradientColors?.map((color) => new THREE.Color(color));
};


function GradientBackground({ onUpdateActiveColor }) {
  console.log("Received onUpdateActiveColor prop:", onUpdateActiveColor);
  const mountRef = useRef(null);
  const [cityMoods, setCityMoods] = useState([]);
  const [currentCityIndex, setCurrentCityIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(TIMER_INTERVAL);
  const [transition, setTransition] = useState(0.0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const rendererRef = useRef(null);
  const sceneRef = useRef(null);
  const cameraRef = useRef(null);
  const clockRef = useRef(new THREE.Clock());

  useEffect(() => {
  /*const fetchCityMoods = async () => {
      try {
        const response = await fetch("https://moods-backend-kz44.onrender.com/api/moods");

        const data = await response.json();
        console.log("City Moods from API:", data);
        setCityMoods(data);
      } catch (error) {
        console.error("Error fetching city moods:", error);
      }
    }*/
   /*const fetchCityMoods = async () => {
      // Replace API call with mock data
      const mockData = [
  { city: "New York", mood: "serious", headlines: [{ title: "Heavy snow expected" }, { title: "Stocks tumble as market reacts to inflation fears" }, { title: "Subway expansion plans unveiled" }] },
  { city: "Tokyo", mood: "angry", headlines: [{ title: "Mass protests against new policy" }, { title: "Commuters frustrated by train delays" }, { title: "Citizens demand more accountability" }] },
  { city: "Paris", mood: "concerned", headlines: [{ title: "Rising Seine river sparks flood fears" }, { title: "Healthcare workers demand better pay" }, { title: "Increase in pickpocketing incidents reported" }] },
  { city: "London", mood: "hopeful", headlines: [{ title: "New green initiative gains traction" }, { title: "Record number of volunteers for charity events" }, { title: "Sunny weekend ahead for the capital" }] },
  { city: "Rio de Janeiro", mood: "festive", headlines: [{ title: "Carnival celebrations kick off in style" }, { title: "Street performers delight crowds" }, { title: "Local bands showcase talents at festival" }] },
  { city: "Cape Town", mood: "calm", headlines: [{ title: "Sunny skies and warm beaches" }, { title: "Community garden project flourishes" }, { title: "Tourists flock to Table Mountain" }] },
  { city: "Mumbai", mood: "worried", headlines: [{ title: "Air quality levels hit dangerous thresholds" }, { title: "Flood warnings issued for coastal areas" }, { title: "Rising food prices spark concerns" }] },
  { city: "Berlin", mood: "thoughtful", headlines: [{ title: "Art installations highlight social issues" }, { title: "New book explores history of the city" }, { title: "Innovative startups tackle climate challenges" }] },
  { city: "Shanghai", mood: "energetic", headlines: [{ title: "Tech conference draws global attention" }, { title: "Nightlife in full swing post-pandemic" }, { title: "High-speed train sets new records" }] },
  { city: "Sydney", mood: "relaxed", headlines: [{ title: "Bondi Beach packed with surfers" }, { title: "Outdoor concerts light up the harbor" }, { title: "Residents enjoy peaceful evening walks" }] },
  { city: "Moscow", mood: "tense", headlines: [{ title: "Military exercises raise eyebrows" }, { title: "Political turmoil sparks debates" }, { title: "Citizens voice concerns over new regulations" }] },
  { city: "Los Angeles", mood: "excited", headlines: [{ title: "Oscars nominations announced" }, { title: "Hollywood celebrates box office successes" }, { title: "Local sports team advances to finals" }] },
  { city: "Toronto", mood: "optimistic", headlines: [{ title: "Economic growth outpaces predictions" }, { title: "New housing developments announced" }, { title: "Climate action plan praised by experts" }] },
  { city: "Seoul", mood: "creative", headlines: [{ title: "K-pop idols dominate global charts" }, { title: "Design festival attracts top talents" }, { title: "Startup ecosystem booming" }] },
  { city: "Buenos Aires", mood: "melancholy", headlines: [{ title: "Tributes pour in for beloved tango artist" }, { title: "Economic challenges weigh on residents" }, { title: "Historic neighborhoods reflect past glories" }] },
  { city: "Istanbul", mood: "curious", headlines: [{ title: "New archeological discovery in the city" }, { title: "Traditional cuisine festival delights visitors" }, { title: "Bosporus ferry tours gain popularity" }] },
];

  
      console.log("Using mock city moods:", mockData);
      setCityMoods(mockData);
    };*/

    const fetchCityMoods = async () => {
      try {
        // Define the base URL for your Google Sheets
        const sheetUrl = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTM4fZ4H0ieYeq8-NIyFcparGbAuwIDxcvMw-2HzxlBVEbQKUaTEscClxcvHboqxeueAfqlKiN9TGlq/pub?output=csv";
    
        // Add a cache-buster to ensure fresh data
        const cacheBuster = `&nocache=${new Date().getTime()}`;
        const fullUrl = `${sheetUrl}${cacheBuster}`;
    
        // Fetch the data
        const response = await fetch(fullUrl);
        if (!response.ok) {
          throw new Error(`Failed to fetch city moods: ${response.statusText}`);
        }
    
        // Parse the CSV data
        const csvData = await response.text();
    
        // Convert the CSV to JSON
        const parsedData = csvData.split("\n").slice(1).map((row) => {
          const [city, mood, headline1, headline2, headline3] = row.split(",");
    
          // Sanitize the data by removing extra quotes and trimming whitespace
          const sanitize = (str) => str?.replace(/['"]+/g, "").trim();
    
          return {
            city: sanitize(city),
            mood: sanitize(mood).toLowerCase(),
            headlines: [
              { title: sanitize(headline1) },
              { title: sanitize(headline2) },
              { title: sanitize(headline3) },
            ],
          };
        });
    
        // Update state with the fetched data
        console.log("Fetched and sanitized city moods:", parsedData); // Debugging log
        setCityMoods(parsedData);
      } catch (error) {
        console.error("Error fetching city moods:", error);
      }
    };
    
    

    fetchCityMoods();
  }, []);

  useEffect(() => {
    if (!rendererRef.current) {
      const renderer = new THREE.WebGLRenderer();
      const scene = new THREE.Scene();
      const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 10);
      camera.position.z = 1;

      renderer.setSize((window.innerWidth)/1.3, window.innerHeight);
      mountRef.current.appendChild(renderer.domElement);

      rendererRef.current = renderer;
      sceneRef.current = scene;
      cameraRef.current = camera;

    const handleResize = () => {
        if (window.innerWidth <= 768) {
          renderer.setSize(window.innerWidth, window.innerHeight);
        } else {
          renderer.setSize(window.innerWidth/1.30, window.innerHeight);
        }
      };
      

     /* const handleResize = () => {
        renderer.setSize(window.innerWidth, window.innerHeight);
      };*/
      window.addEventListener("resize", handleResize);

       handleResize();

      return () => {
        window.removeEventListener("resize", handleResize);
        renderer.dispose();
      };
    }
  }, []);

  useEffect(() => {
    if (cityMoods.length > 0) {
        const renderer = rendererRef.current;
        const scene = sceneRef.current;
        const camera = cameraRef.current;
        const clock = clockRef.current;

        // Get the current mood and corresponding gradient colors
        const currentMood = cityMoods[currentCityIndex]?.mood;
        const gradientColors = getGradientColors(currentMood);
        const firstColor = gradientColors?.[0]?.getStyle(); // Extract the first color (as hex)

        // Debug logs
        console.log("Current mood:", currentMood);
        console.log("Gradient colors for current mood:", gradientColors?.map((color) => color.getStyle()));
        console.log("First color for pills:", firstColor);

        // Pass the first color to the parent via onUpdateActiveColor
        if (onUpdateActiveColor) {
          console.log("Updating active color with:", firstColor);
            onUpdateActiveColor(firstColor);
        }else {
          console.log("onUpdateActiveColor is not defined.");
      }

        // Shader uniforms for the background gradient
        const uniforms = {
            colors1: { value: getGradientColors(cityMoods[currentCityIndex]?.mood) },
            colors2: { value: getGradientColors(cityMoods[(currentCityIndex + 1) % cityMoods.length]?.mood) },
            transition: { value: 0.0 },
            time: { value: 0.0 },
        };

        console.log("Uniforms for Shader:", uniforms);

        // Define the shader material
        const material = new THREE.ShaderMaterial({
            uniforms,
            vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform vec3 colors1[3];
                uniform vec3 colors2[3];
                uniform float transition;
                uniform float time;
                varying vec2 vUv;

                void main() {
                    float wave = sin(vUv.x * 10.0 + time * 2.0) * 0.1;
                    vec3 color1 = mix(
                        mix(colors1[0], colors1[1], smoothstep(0.0, 0.5, vUv.y + wave)),
                        colors1[2],
                        smoothstep(0.5, 1.0, vUv.y + wave)
                    );

                    vec3 color2 = mix(
                        mix(colors2[0], colors2[1], smoothstep(0.0, 0.5, vUv.y - wave)),
                        colors2[2],
                        smoothstep(0.5, 1.0, vUv.y - wave)
                    );

                    vec3 finalColor = mix(color1, color2, transition);
                    gl_FragColor = vec4(finalColor, 1.0);
                }
            `,
        });

        // Create the plane and add it to the scene
        const plane = new THREE.PlaneGeometry(2, 2);
        const mesh = new THREE.Mesh(plane, material);
        scene.add(mesh);

        // Animation loop
        const animate = () => {
            uniforms.transition.value = transition; // Retain transition for blending
            uniforms.time.value = clock.getElapsedTime(); // Update time uniform
            renderer.render(scene, camera);
            requestAnimationFrame(animate);
        };
        animate();

        // Cleanup on unmount
        return () => {
            scene.remove(mesh);
            plane.dispose();
            material.dispose();
        };
    }
}, [cityMoods, currentCityIndex, transition, onUpdateActiveColor]);


  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === 6) {
          setIsTransitioning(true);
          setTransition(0.0);
        } else if (prev === 0) {
          setCurrentCityIndex((prevIndex) => (prevIndex + 1) % cityMoods.length);
          setTimeLeft(TIMER_INTERVAL);
          setIsTransitioning(false);
          setTransition(0.0);
        }
        return prev > 0 ? prev - 1 : TIMER_INTERVAL;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [cityMoods]);

  useEffect(() => {
    if (isTransitioning) {
      const interval = setInterval(() => {
        setTransition((prev) => Math.min(prev + 0.02, 1.0));
      }, 100);
      return () => clearInterval(interval);
    }
  }, [isTransitioning]);

  return (
    <GradientContainer>
  <div ref={mountRef} />
  <BottomLeftContainer>
    <BottomLeftText>Hey, I'm Marcha</BottomLeftText>
    <BottomLeftSmallText>
      and I'm an interdisciplinary technologist exploring all the ingenious ways technology can be used as a medium to innovate, express, and reimagine human connections and storytelling.
      <MobileScrollText>
        Scroll for works <ArrowCircle>↓</ArrowCircle>
      </MobileScrollText>
    </BottomLeftSmallText>
    
  </BottomLeftContainer>
  <TopRightText>
    <TitleText>Local EQ</TitleText>
   <b>Current City: {cityMoods[currentCityIndex]?.city} - Mood: {cityMoods[currentCityIndex]?.mood}</b>
      <HeadlinesContainer>
   <b>Local headlines:</b>
  {cityMoods[currentCityIndex]?.headlines?.map((headline, index) => {
    const truncatedTitle = headline.title.split(" ").slice(0, 8).join(" ");
    const isTruncated = headline.title.split(" ").length > 8;
    return (
      <div key={index}>
        {isTruncated ? `${truncatedTitle}...` : headline.title}
      </div>
    );
  })}
    </HeadlinesContainer>
    <NextCityText>
      Next City: {cityMoods[(currentCityIndex + 1) % cityMoods.length]?.city} - Mood: {cityMoods[(currentCityIndex + 1) % cityMoods.length]?.mood}
    </NextCityText>
    <TimerText>Next City in: {formatTime(timeLeft)}</TimerText>
    <AboutText>
    About this experiment: <br />
    Local EQ is a research project utlizing cultural data—like current regional news— to translate emotional landscapes into adaptive interfaces. This iteration uses background color gradients to reflect local moods and begs the question how other design elements might adapt to emotion. Excited by this topic? Let’s chat over coffee.    Made with ❤️ and: GCP, Three.js, OpenAI.<br></br>
    <ReachOutButton href="mailto:majj.johnson@gmail.com" target="_blank" rel="noopener noreferrer">
        Connect with me
      </ReachOutButton>
  </AboutText>
  </TopRightText>
  
</GradientContainer>

  );
}

export default GradientBackground;






